import { TypePolicies } from '@apollo/client'

export const auth = (): TypePolicies => {
  return {
    NamespaceAuthQuery: {
      merge: true,
    },
  }
}
